import React, { useEffect } from 'react'
import img1 from "../../assets/images/career/cir-large.svg";
import img2 from "../../assets/images/career/cir-midium.svg";
import img3 from "../../assets/images/career/cir-small.svg";
import { Button } from 'rsuite';
import { useNavigate } from 'react-router-dom';
function ServiceFooterCtaSection({data ,openModal}) {

  useEffect(() => {
    const container = document.querySelector('.gt-cont1');
    const images = container.querySelectorAll('.anim');
    
    const handleMouseMove = (event) => {
      const rect = container.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      
      const moveX = (mouseX - centerX) * 0.15;
      const moveY = (mouseY - centerY) * 0.15;
      
      images.forEach(image => {
        const depth = parseFloat(image.dataset.depth) || 0.5;
        const moveRatioX = moveX * depth;
        const moveRatioY = moveY * depth;
        
        image.style.transform = `translate(${moveRatioX}px, ${moveRatioY}px)`;
      });
    };

    container.addEventListener('mousemove', handleMouseMove);

    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const path= window.location.pathname
  const navigate = useNavigate();

  const handleClick = () => {
      navigate('/request-a-demo', { state: { ttl2: "Let's connect" ,dec:"Let's bridge the gap and bring ideas to reality: Connect with us now!",path:{path} } });
  };


  return (
    <>
        <section className='career-sub-footer-new'>
            <div className='container'>
                <div className='gt-cont gt-cont1'>
                    <p className='sm-para'>{data[0].CtaDescriptiom}</p>
                    <Button to={data[0].CtaBtnLink} className='btn' target={data[0].CtaBtnTarget} onClick={handleClick}>
                    <span>{data[0].CtaBtnText}</span></Button>
                      <img src={img1} alt="img-cover" className="anim follow-img"></img>
                      <img src={img2} alt="img-cover" className="anim follow-img1 "></img>
                      <img src={img3} alt="img-cover" className="anim follow-img2"></img>
                </div>
            </div>
        </section>
    </>

  )
}

export default ServiceFooterCtaSection;
